import { Field, Float, Int, ObjectType } from '@nestjs/graphql'

/**
 * One of the review campaigns an author ran while the cancelled subscription was active, with the
 * figures the author app shows under it - counted the same way, so the two never disagree. [sc-28213]
 */
@ObjectType()
export class CancellationCampaignDto {
  @Field(t => Int)
  arcId!: number

  @Field({ nullable: true })
  bookTitle?: string

  @Field({ nullable: true })
  bookCover?: string

  @Field(t => Int, { nullable: true })
  status?: number

  @Field(t => Int, { nullable: true })
  arcType?: number

  /** Required review sites, as `ARCS.REVIEWS.FLAGS` bits. */
  @Field(t => Int, { nullable: true })
  reviewFlags?: number

  @Field({ nullable: true })
  liveDate?: Date

  /** When the campaign stops (or stopped) taking readers - the author app's "Ends on" / "Ended on". */
  @Field({ nullable: true })
  stopDownloadDate?: Date

  @Field(t => Float)
  averageRating!: number

  /** Every claim, withdrawn ones included - the author app's "Participants". */
  @Field(t => Int)
  participantCount!: number

  @Field(t => Int)
  reviewCount!: number

  @Field(t => Int)
  impressionCount!: number

  @Field(t => Int)
  viewCount!: number

  /** Readers who currently have it saved. */
  @Field(t => Int)
  saveCount!: number
}
